import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet"
import Navbar from '../components/parts/Navbar'
import Hbar from '../components/Hbar'
import Game from '../components/Game'
import Loader from '../components/Loader'
import GoogleAd from '../components/GoogleAd'
import EzoicAd from '../components/EzoicAd'
import StaticContent from '../components/StaticContent'
import Content from '../components/Content'
import { callAPITag, callAPI, getCookie, callAPIQuery } from '../js/main.js';
import favicon from '../images/favicon/favicon.png';
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'


const IndexPage = () => {

  const intl = useIntl();

  const [dataAPI, setDataAPI] = useState(null);
  const [dataFilterAPI, setdataFilterAPI] = useState(null);
  const [linkIFrame, setlinkIFrame] = useState(null);
  const [descriptionIFrame, setdescriptionIFrame] = useState(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const [searchFakeQuery, setFakeSearchQuery] = useState(null);
  const [searchTag, setSearchTag] = useState("All");
  const [searchProvider, setSearchProvider] = useState(null);
  const [searchURL, setSearchURL] = useState(null);
  const [LoaderStatus, setLoaderStatus] = useState(true);
  const [device, setDevice] = useState(null)

  const filterBySearch = async (device) => {
    setlinkIFrame(null);
    setdescriptionIFrame(null);
    const data = await callAPIQuery(searchQuery, device.device);
    setdataFilterAPI(data.data);
    return;
  }

  useEffect(() => {
    if(typeof window.ezstandalone !== 'undefined')  {
        try {
            // ezoic
            window.ezstandalone.cmd.push(function () {
                window.ezstandalone.define(124, 125);
                window.ezstandalone.enable();
                window.ezstandalone.display();
            });
        }catch (ex) { console.error(ex); }
    }
}, [])

  useEffect(() => {

    let search = getCookie("search")
    let device;
    setSearchQuery(search)
    setFakeSearchQuery(search)

    // Set width of screen for ads size
    if (window.innerWidth < 768) device = "mobile"
    else if (window.innerWidth < 1024 && window.innerWidth > 768) device = "tablet"
    else if (window.innerWidth < 1536 && window.innerWidth > 1024) device = "desktopxl"
    else device = "desktop2xl"

    setDevice(device)

    setSearchURL(window.location.toString());
    const defineData = async () => {
      let data = await callAPI(device);
      setDataAPI(data);


      if (search)
        setdataFilterAPI(data);
      else
        setdataFilterAPI(data);
      setLoaderStatus(false);
    }

    defineData();
  }, [])

  useEffect(() => {
    if (searchQuery)
    filterBySearch({device})
  }, [dataAPI])

  useEffect(() => {
    if (searchQuery)
      filterBySearch({device})
  }, [searchQuery])

  useEffect(async () => {

    if (searchTag === "All") setdataFilterAPI(dataAPI);
    else if (searchTag) setdataFilterAPI(await callAPITag(searchTag, device));

  }, [searchTag])

  useEffect(() => {
    window.scrollTo(0, 0);
    setSearchURL(window.location.toString());
  }, [linkIFrame])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{ ` ${intl.formatMessage({ id: 'seo-title' })} ` }</title>
        <meta name='description' content={ ` ${intl.formatMessage({ id: 'seo-description' })} ` } />
        <link rel="canonical" href="https://games.add.games/" />
        <link rel="icon" type="image/png" href={favicon} size="32x32" />
      </Helmet>

      <div className="fixed w-full z-40 lg:hidden">
        <Navbar
          searchURL={searchURL}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          searchFakeQuery={searchFakeQuery}
          setFakeSearchQuery={setFakeSearchQuery}
          searchTag={searchTag}
          setSearchTag={setSearchTag}
          setSearchProvider={setSearchProvider}
        />
      </div>
      <div className="flex">
        <div className="z-10 hidden lg:block min-h-[100vh] shadow-customerBoxShadow border-r-0 border-greyB font-sans">
          <Hbar
            searchURL={searchURL}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            searchFakeQuery={searchFakeQuery}
            setFakeSearchQuery={setFakeSearchQuery}
            searchTag={searchTag}
            setSearchTag={setSearchTag}
            setSearchProvider={setSearchProvider}
          />
          <div className="ml-[42.5px] mt-[30px]">
            {/* <GoogleAd
              client="ca-pub-2329173014490955" slot="1393351102" format=""
              style={{ width: "300px", height: "250px" }}
            /> */}
            <div id={`ezoic-pub-ad-placeholder-124`}/>
            {/* <StaticContent><div id={`ezoic-pub-ad-placeholder-124`} /></StaticContent> */}
          </div>
        </div>
        <div className="min-h-[calc(100vh-70.7px)] lg:min-h-[calc(100vh)] min-w-[100%] lg:min-w-[calc(100%-385px)] bg-grey mt-[70.7px] lg:mt-0">

          <div className="ml-[calc((100%-300px)/2)] lg:ml-[10px] mt-[10px] flex md:block">
            {device === null ? null :
              device === "desktopxl" || "desktop2xl" ?
                // <div>
                //   <GoogleAd
                //     client="ca-pub-2329173014490955" slot="6616939387" format=""
                //     style={{ width: "728px", height: "90px" }}
                //   />
                // </div>
                <div id={`ezoic-pub-ad-placeholder-125`}/>
                // <div className="ml-[42.5px] mt-[30px] w-[728px] h-[90px]"><StaticContent><div id={`ezoic-pub-ad-placeholder-125`} /></StaticContent></div>
                :
                <div id={`ezoic-pub-ad-placeholder-125`}/>
                // <div className="ml-[42.5px] mt-[30px] w-[300px] h-[250px]"><StaticContent><div id={`ezoic-pub-ad-placeholder-125`} /></StaticContent></div>
                // <div>
                //   <GoogleAd
                //     client="ca-pub-2329173014490955" slot="6616939387" format=""
                //     style={{ width: "300px", height: "250px" }}
                //   />
                // </div>
            }
          </div>
          {LoaderStatus ? <div className="mt-[-250px] lg:mt-[-90px]"><Loader /></div> : null}
          <div className="overflow-auto	h-[calc(100vh-70.7px)]">
            <Game
              data={dataFilterAPI}
              setlinkIFrame={setlinkIFrame}
              setdescriptionIFrame={setdescriptionIFrame}
              device={device}
            />
          </div>

        </div>
      </div>
      <Content />
    </>
  )
}

export default IndexPage